import { TripAccessorialsPanel } from '../features/trip-accessorials/components/TripAccessorialsPanel';

/** The accessorials proposed from the trip's actual timeline, for the trip page. It loads and reports its own states. */
export function TripAccessorialsSection({ tripId }: { tripId: string }) {
  return <TripAccessorialsPanel tripId={tripId} />;
}
